<template>
  <div class="event-detail">
    <navbar bg="transparent" />
    <div v-loading="loading" class="event-detail-inner">
      <div class="title">
        {{ detail.title || "三分钟教你认识名门修谱" }}
      </div>
      <img v-if="detail.image" :src="detail.image" alt="" class="banner">
      <div class="content" v-html="detail.content"></div>
      <div class="bottom">
        <div class="date">{{ detail.cdatetime || "2020-08-09" }}</div>
        <div class="view-count">
          浏览 <span class="red">{{ detail.view_count || "0" }}</span> 次
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/h5/Navbar";
import otherApis from "@/apis/other";

export default {
  name: "EventDetail",
  components: {
    Navbar
  },
  data() {
    return {
      detail: {},
      loading: false
    };
  },
  created() {
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      this.loading = true;
      try {
        const {
          data: { article_info }
        } = await otherApis.articleDetail({
          id: this.$route.params.id
        });

        this.detail = article_info || {};
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scope>
.event-detail {
  background-color: #fff;
  /* prettier-ignore */
  min-height: calc(100vh - 50PX);
  // box-sizing: border-box;
  // display: flex;
  // justify-content: center;
  // padding: 15px 0;
  // height: calc(100vh - 70px);

  .banner {
    width: 100%;
    height: 400px;
    object-fit: contain;
  }

  .event-detail-inner {
    display: flex;
    flex-flow: column nowrap;
    width: 1045px;
    margin: 0 auto;
    padding: 40px;
    box-sizing: border-box;
    background: #f7f7f7;
    border-radius: 10px;

    .title {
      font-size: 56px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }

    .content {
      font-size: 14px;
      line-height: 1.4;
      font-size: 44px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-top: 60px;
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #b5b5b5;
      font-size: 40px;
      margin-top: 48px;

      .red {
        color: #8c4134;
      }
    }
  }
}
</style>
